import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faArrowDownLeftAndArrowUpRightToCenter } from "@fortawesome/pro-solid-svg-icons";

@Component({
    selector: "app-expand",
    templateUrl: "./expand.component.html",
    styleUrls: ["./expand.component.scss"],
    standalone: false
})
export class ExoandDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,

    public dialogRef: MatDialogRef<ExoandDialogComponent>
  ) {
    if (data) {
      this.chart = data.chart;
      this.form = data.form;
    }
  }

  chart!: any;
  form: any;

  faArrowDownLeftAndArrowUpRightToCenter =
    faArrowDownLeftAndArrowUpRightToCenter;
  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {}
}
